/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetSpendRulesOverviewSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetSpendRulesOverviewSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetSpendRulesOverviewSecurity = {
  option1?: GetSpendRulesOverviewSecurityOption1 | undefined;
  option2?: GetSpendRulesOverviewSecurityOption2 | undefined;
};

export type GetSpendRulesOverviewRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetSpendRulesOverviewSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetSpendRulesOverviewSecurityOption1$outboundSchema: z.ZodMiniType<
  GetSpendRulesOverviewSecurityOption1$Outbound,
  GetSpendRulesOverviewSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getSpendRulesOverviewSecurityOption1ToJSON(
  getSpendRulesOverviewSecurityOption1: GetSpendRulesOverviewSecurityOption1,
): string {
  return JSON.stringify(
    GetSpendRulesOverviewSecurityOption1$outboundSchema.parse(
      getSpendRulesOverviewSecurityOption1,
    ),
  );
}

/** @internal */
export type GetSpendRulesOverviewSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetSpendRulesOverviewSecurityOption2$outboundSchema: z.ZodMiniType<
  GetSpendRulesOverviewSecurityOption2$Outbound,
  GetSpendRulesOverviewSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getSpendRulesOverviewSecurityOption2ToJSON(
  getSpendRulesOverviewSecurityOption2: GetSpendRulesOverviewSecurityOption2,
): string {
  return JSON.stringify(
    GetSpendRulesOverviewSecurityOption2$outboundSchema.parse(
      getSpendRulesOverviewSecurityOption2,
    ),
  );
}

/** @internal */
export type GetSpendRulesOverviewSecurity$Outbound = {
  Option1?: GetSpendRulesOverviewSecurityOption1$Outbound | undefined;
  Option2?: GetSpendRulesOverviewSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetSpendRulesOverviewSecurity$outboundSchema: z.ZodMiniType<
  GetSpendRulesOverviewSecurity$Outbound,
  GetSpendRulesOverviewSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetSpendRulesOverviewSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetSpendRulesOverviewSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getSpendRulesOverviewSecurityToJSON(
  getSpendRulesOverviewSecurity: GetSpendRulesOverviewSecurity,
): string {
  return JSON.stringify(
    GetSpendRulesOverviewSecurity$outboundSchema.parse(
      getSpendRulesOverviewSecurity,
    ),
  );
}

/** @internal */
export type GetSpendRulesOverviewRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetSpendRulesOverviewRequest$outboundSchema: z.ZodMiniType<
  GetSpendRulesOverviewRequest$Outbound,
  GetSpendRulesOverviewRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getSpendRulesOverviewRequestToJSON(
  getSpendRulesOverviewRequest: GetSpendRulesOverviewRequest,
): string {
  return JSON.stringify(
    GetSpendRulesOverviewRequest$outboundSchema.parse(
      getSpendRulesOverviewRequest,
    ),
  );
}
